
import { CTASection } from "@/components/CTASection";

export const LaserDentistryCTA = () => {
  const handleBookAppointment = () => {
    window.open("https://www.healthcoco.com/nagpur/doctor/dr-hemant-asrani-endodontist-dentist/USRH249D644", "_blank");
  };

  return (
    <CTASection
      title="Advanced Dental Care with Laser Technology"
      description="At Asrani Dental in Sadar, Nagpur, our laser dentistry services provide precision care with greater comfort and faster healing. Schedule your consultation today."
      primaryButtonText="Book an Appointment"
      secondaryButtonText="Learn More"
      primaryButtonAction={handleBookAppointment}
      secondaryButtonAction={() => window.location.href = "/about"}
    />
  );
};
